import React,{Component,Fragment} from "react";
import {Switch,Route,Redirect} from "react-router-dom";
import NotFound from "../pages/NotFound"
import Login from "../pages/Login";
import Users from "../pages/Users";
import UserUpdate from "../pages/UserUpdate";
import AllPayments from "../pages/AllPayments";
import AllDeposit from "../pages/AllDeposit";
import AllWithdrew from "../pages/Withdrew";
import WithdrewEdit from "../pages/WithdrewEdit";
import UserDetails from "../pages/UserDetails";
import WithdrewPending from "../pages/WithdrewPending";
import CoinsAirdrop from "../pages/CoinsAirdrop";
import AddAirdropCurrency from "../pages/AddAirdropCurrency";
import EditAirdropCurrency from "../pages/EditAirdropCurrency";
import Package from "../pages/Package";
import AddPackage from "../pages/AddPackage";
import EditPackage from "../pages/EditPackage";
import Info from "../pages/Info";
import AddInfo from "../pages/AddInfo";
import EditInfo from "../pages/EditInfo";
import Ads from "../pages/Ads";
import AddAds from "../pages/AddAds";
import EditAds from "../pages/EditAds";
import Settings from "../pages/Settings";


class RouterPage extends Component {
    render() { 
        return ( 
         <Fragment>   
            <Switch>
                <Route exact path="/login" component={Login}/>
                <Route exact path="/currency/airdrop" component={CoinsAirdrop}/>
                <Route exact path="/currency/add/airdrop" component={AddAirdropCurrency}/>
                <Route exact path="/currency/airdrop/edit/:id" component={EditAirdropCurrency}/>
                <Route exact path="/" component={Users}/>
                <Route exact path="/user/edit/:id" component={UserUpdate}/>
                <Route exact path="/user/details/:id" component={UserDetails}/>
                <Route exact path="/payments" component={AllPayments}/>
                <Route exact path="/deposit" component={AllDeposit}/>
                <Route exact path="/withdrew" component={AllWithdrew}/>
                <Route exact path="/withdrew/pending" component={WithdrewPending}/>
                <Route exact path="/withdrew/edit/:id" component={WithdrewEdit}/>
                <Route exact path="/package" component={Package}/>
                <Route exact path="/package/add" component={AddPackage}/>
                <Route exact path="/package/edit/:id" component={EditPackage}/>
                <Route exact path="/info" component={Info}/>
                <Route exact path="/info/add" component={AddInfo}/>
                <Route exact path="/info/edit/:id" component={EditInfo}/>
                <Route exact path="/ads" component={Ads}/>
                <Route exact path="/ads/add" component={AddAds}/>
                <Route exact path="/ads/edit/:id" component={EditAds}/>
                <Route exact path="/settings" component={Settings}/>

                <Route component={NotFound}/>
          </Switch>
        </Fragment>
         );
    }
}
 
export default RouterPage;